"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createItemContextsForDeleteStoreUpdate_1 = require("./helpers/createItemContextsForDeleteStoreUpdate");
var markItemsJunkNotJunkBasedOnItemIds_1 = require("./helpers/markItemsJunkNotJunkBasedOnItemIds");
var deleteItemsStoreUpdate_1 = require("owa-mail-actions/lib/triage/deleteItemsStoreUpdate");
var Store_1 = require("owa-mail-store/lib/store/Store");
var doesFolderIdEqualName_1 = require("owa-session-store/lib/utils/doesFolderIdEqualName");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Mark item as junk/not junk
 * @param itemIds the specified item Ids to be marked as junk
 * @param actionSource the source that initiated the action
 * @param state the MarkItemJunkNotJunkFromReadingPaneState which contains the original table view
 */
exports.default = legacy_1.select({
    item: function (itemId) { return Store_1.default.items.get(itemId); },
})(function markItemJunkNotJunkFromReadingPane(itemId, actionSource, instrumentationContexts, state) {
    var item = state.item;
    var isJunkFolder = doesFolderIdEqualName_1.default(item.ParentFolderId.Id, 'junkemail');
    markItemsJunkNotJunkBasedOnItemIds_1.default([itemId], !isJunkFolder /* isJunkValueToSet*/, actionSource, instrumentationContexts, function () {
        var itemContexts = createItemContextsForDeleteStoreUpdate_1.default([itemId]);
        // Dispatch action to update the store state
        deleteItemsStoreUpdate_1.default(itemContexts, item.ParentFolderId.Id);
    });
});
//# sourceMappingURL=markItemJunkNotJunkFromReadingPane.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/markItemJunkNotJunkFromReadingPane.js
// module id = 5661
// module chunks = 62